import React, { useState } from "react";
import { Organization } from "../common/ObjectTypes";
import { DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import Pagination from "../common/Pagination";
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../helpers/authHeader";
import tailwindClassnames from "../common/TaildwindClassnames";

type OrganizationsListTypes = {
  organizations: Organization[];
  selectedOrg: Organization;
  orgToAdd: Organization;
  addOrg: boolean;
  pageCount: number;
  totalCount: number;
  recordStart: number;
  recordEnd: number;
  pageSize: number;
  loading: boolean;
  handlePageClick: (selectedItem: { selected: number }) => void;
  onClickAdd: Function;
  onSelectOrg: Function;
  onSearch: Function;
  onChangeSearch: Function;
  searchQuery: any;
};

const OrgnizationsList = ({
  organizations,
  selectedOrg,
  orgToAdd,
  addOrg,
  onClickAdd,
  onSelectOrg,
  pageCount,
  totalCount,
  handlePageClick,
  recordStart,
  recordEnd,
  pageSize,
  searchQuery,
  onSearch,
  onChangeSearch,
  loading,
}: OrganizationsListTypes) => {
  const [subStr, setSubStr] = useState("");
  const currentUser = getCurrentUser();

  return (
    <div className="p-6">
      {/* List */}
      <div className="flex flex-row justify-between">
        <h1 className={tailwindClassnames.tableTitle}>Organizations</h1>
      </div>
      {currentUser.isSystemAdmin && (
        <div className="flex flex-row items-center justify-end mt-4">
          {/* <div className="flex flex-row mr-auto w-1/3">
            <TextInput
              name=""
              label=""
              onChange={onChangeSearch}
              value={searchQuery.name}
              placeholder="Filter by name"
              error={null}
              initialFocus={false}
              className={tailwindClassnames.searchTextInput}
              disabled={false}
              type=""
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  onSearch();
                }
              }}
            />
            <button
              onClick={() => onSearch()}
              className={tailwindClassnames.searchButton}
            >
              Search
            </button>
          </div> */}
          <Link
            to="/organization/add"
            className={tailwindClassnames.lookupButton}
          >
            Add
          </Link>
        </div>
      )}
      {/* list */}
      <table className={tailwindClassnames.tableContainer}>
        <thead className={tailwindClassnames.tableHead}>
          <tr>
            <th className={tailwindClassnames.tableHeadText}>Name </th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((org: Organization, index: number) => {
            const rowClass =
              index % 2 === 0 ? "bg-grayScale-200" : "bg-grayScale-100";
            return (
              <tr
                key={org.organizationId}
                className={rowClass + tailwindClassnames.tableBody}
                onClick={() => onSelectOrg(org.organizationId)}
              >
                <td className={tailwindClassnames.tableBodyText}>
                  {org.name}{" "}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        handlePageClick={handlePageClick}
        pageCount={pageCount}
        loading={loading}
        recordStart={recordStart}
        recordEnd={recordEnd}
        totalCount={totalCount}
        pageSize={searchQuery.pageSize}
        selectPage={false}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default OrgnizationsList;
